export default {
  name: "user-round",
  contents: '<circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 0 0-16 0"/>',
  attrs: {
    viewBox: "0 0 24 24",
  },
  tags: ["user", "person", "account", "profile", "avatar", "round"],
};
